
import magazineService from '../services/magazineService';

export const getPaginatedMagazines = async (params, setState, setLoading) => {
  setLoading(true);
  try {
    const result = await magazineService.fetchMagazines(params);
    if (result && result.status) {
      setState({
        magazines: result.data || [],
        offset: result.offset,
        perPage: result.per_page,
        page: result.page,
        total: result.total,
        q: params.q,
      });
    } else {
      console.error('Failed to fetch magazines');
    }
  } catch (error) {
    console.error("Failed to fetch magazines", error);
  } finally {
    setLoading(false);
  }
};

export const loadReleases = async (setReleases) => {
  const data = await magazineService.fetchAllReleases();
  setReleases(data);
};


export const getMagazineById = async (params, setMagazine) => {
  const data = await magazineService.fetchMagazineByID(params);
  setMagazine(data);
};


export const updateReleaseById = async (params, updatedData, setRelease) => {
  const res = await magazineService.updateReleaseById(params, updatedData);
  return res;
};





